<ng-container *transloco="let t">
  <app-page-template>
    <div class="container pb-300-100">
      <div class="py-5">
        <nav class="nav nav-underline">
          <a class="nav-link"
             [routerLink]="[GENERAL_CONDITIONS_ROUTE]"
             routerLinkActive="active">
            {{ t("policy.general.conditions") }}
          </a>
          <a class="nav-link"
             [routerLink]="[INTELLECTUAL_PROPERTY_ROUTE]"
             routerLinkActive="active">
            {{ t("policy.intellectual.property") }}
          </a>
          <a class="nav-link"
             [routerLink]="[COOKIE_POLICY_ROUTE]"
             routerLinkActive="active">
            {{ t("policy.cookie") }}
          </a>
          <a class="nav-link"
             [routerLink]="[COMPLAINTS_AND_DISPUTES]"
             routerLinkActive="active">
            {{ t("policy.complaints.and.disputes") }}
          </a>
          <a class="nav-link"
             [routerLink]="[PERSONAL_DATA_PROTECTION]"
             routerLinkActive="active">
            {{ t("policy.notice.on.personal.data.protection") }}
          </a>
        </nav>
      </div>
      <section class="upper-section-background">
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      </section>
    </div>
  </app-page-template>
</ng-container>
